import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { HelmetProvider } from 'react-helmet-async';

import { Toaster } from '@/components/sonner/sonner';
import TooltipProvider from '@/components/providers/tooltip-provider/tooltip-provider';
import TanstackReactQueryProvider from '@/components/providers/tanstack-query-provider/tanstack-query-provider';
import AppError from '@/components/errors/app-error/app-error';
import DialogProvider from '@/contexts/dialog-context/dialog-provider';
import AuthProvider from '@/contexts/auth-context/auth-provider';

interface AppProviderProps {
  children: React.ReactNode;
}
export default function AppProvider({ children }: AppProviderProps) {
  return (
    <ErrorBoundary FallbackComponent={AppError}>
      <HelmetProvider>
        <BrowserRouter>
          <NuqsAdapter>
            <TanstackReactQueryProvider>
              <AuthProvider>
                <TooltipProvider>
                  <DialogProvider>{children}</DialogProvider>
                </TooltipProvider>
                <Toaster richColors position="top-right" />
              </AuthProvider>
            </TanstackReactQueryProvider>
          </NuqsAdapter>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}
